import React from 'react';
import { Formik, Form, FormikValues } from 'formik';
import { Grid, Typography, Button } from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import LockIcon from '@material-ui/icons/Lock';

import { FullScreenCard, Loading, TextInput } from 'components';
import useGlobalStyles from 'hooks/useGlobalStyles';
import useAuth from 'hooks/useAuth';

import { validationSchema } from './components/ValidationSchema';

const SignUp: React.SFC = () => {
  // Local State
  const globalClasses = useGlobalStyles();
  const { isLoading, signIn } = useAuth();
  
  const initialValues = {
    email: '',
    password: ''
  };
  const initialErrors = {
    email: '',
    password: ''
  }

  const handleSignIn = async (values: FormikValues) => {
    const { email, password } = values;
    await signIn(email, password);
  }

  const renderForm = () => (
    <Formik
      initialValues={initialValues}
      initialErrors={initialErrors}
      validationSchema={validationSchema}
      onSubmit={handleSignIn}
    >
      { ({ isValid, values, handleChange, handleBlur, touched, errors }) => (
        <Form>
          <Grid className={globalClasses.gridNoSpacing} container spacing={0} direction="column">
            <Grid item>
              <TextInput
                title="Email"
                name="email"
                placeholder="person@example.com"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                errorMessage={touched.email && errors.email}
                endAdornment={<AccountCircleIcon />}
              />
            </Grid>
            <Grid item>
              <TextInput
                title="Password"
                name="password"
                placeholder="********"
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                errorMessage={touched.password && errors.password}
                endAdornment={<LockIcon />}
                type="password"
              />
            </Grid>
            <Grid item>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <Button variant="outlined" href="/signup">
                    Sign Up
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} style={{ textAlign: 'right' }}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={!isValid || isLoading}
                    onClick={() => handleSignIn(values)}
                  >
                    {isLoading && (
                      <Loading size={20} style={{ marginTop: '-10px' }} />
                    )}
                    {!isLoading && 'Sign In'}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );

  const renderFooter = () => (
    <Typography variant="subtitle1">
      <a href="/reset?mode=forgotPassword">Forgot Password</a>
    </Typography>
  );

  return (
    <FullScreenCard size="small" footer={renderFooter()}>
      {renderForm()}
    </FullScreenCard>
  );
}

export default SignUp;
